import type { RfaAddress } from '@innogy/feh/rfa';

export const solarPanelsWizardFormId = 'solarPanelsWizardForm';
export const solarPanelsWizardFormConsumptionControlId = `${solarPanelsWizardFormId}.consumption`;

export type SolarPanelsWizardHouseAcquisitionOption =
  | 'bought_with_own_roof'
  | 'other';

export interface SolarPanelsWizardFormValues {
  address: RfaAddress;
  consumption: string;
  houseType: SolarPanelsWizardHouseAcquisitionOption;
}
